var ADDING_TO_CART = false;
var VALIDATING_CART = false;

/*const PRODUCT_STORE = {
  45518013759709: "45950250483933", // blue 30
  45518013792477: "45950250516701", // blue 60
  45518013235421: "45950268506333", // green 30
  45518013268189: "45950268539101", // green 60
  45518013497565: "45950272569565", // yellow 30
  45518013530333: "45950272602333", // yellow 60
  45518012940509: "45950277943517", // ultra c 30
  45518012973277: "45950277976285", // ultra c 60
  45518012580061: "45950282006749", // mag 30
  45518012612829: "45950282039517", // mag 60
};*/

const PRODUCT_STORE = {
  45518013759709: "45950277943517", // ultra c 30
  45518013792477: "45950277943517", // ultra c 30
  45518013235421: "45950277943517", // ultra c 30
  45518013268189: "45950277943517", // ultra c 30
  45518013497565: "45950277943517", // ultra c 30
  45518013530333: "45950277943517", // ultra c 30
  45518012940509: "45950277943517", // ultra c 30
  45518012973277: "45950277943517", // ultra c 30
  45518012580061: "45950277943517", // ultra c 30
  45518012612829: "45950277943517", // ultra c 30
};

const PRODUCT_IN_CART = (items, productId) => {
  return items.some(function (item) {
    return item.id == productId;
  });
};

const GET_ITEMS_IN_CART = () => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", "/cart.js", true);
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        const cart = JSON.parse(xhr.responseText);
        resolve(cart.items);
      }
    };
    xhr.send();
  });
};

// Función para obtener la cantidad del producto original
function getQuantityValue() {
  var quantity = $(".js-qty__num").val();
  console.log("Cantidad seleccionada:", quantity);
  return quantity;
}

const ADD_PRODUCT_TO_CART = (productId, quantity, reload = false) => {
  return new Promise((resolve, reject) => {
    if (ADDING_TO_CART) return resolve(false);
    ADDING_TO_CART = true;
    
    const xhrAdd = new XMLHttpRequest();
    xhrAdd.open("POST", "/cart/add.js", true);
    xhrAdd.setRequestHeader(
      "Content-Type",
      "application/x-www-form-urlencoded"
    );
    xhrAdd.onreadystatechange = function () {
      if (xhrAdd.readyState === 4) {
        ADDING_TO_CART = false;
        if (xhrAdd.status === 200) {
          // Actualiza el carrito para reflejar los cambios, si es necesario
          if (reload) {
            window.location.reload();
          }
          resolve(true);
        }else {
          console.error("Error al agregar producto al carrito.");
          reject("Failed to add product to cart.");
        }
      }
    };

   // xhrAdd.send(`quantity=${quantity}&id=${productId}`); para actualizar la cantidad del producto en el FREE
    xhrAdd.send(`quantity=1&id=${productId}`);
  });
};

const REMOVE_PRODUCT_FROM_CART = (productId, reload = false) => {
  return new Promise((resolve, reject) => {
    if (ADDING_TO_CART) return resolve(false);
    ADDING_TO_CART = true;

    const xhrRemove = new XMLHttpRequest();
    xhrRemove.open("POST", "/cart/change.js", true);
    xhrRemove.setRequestHeader(
      "Content-Type",
      "application/x-www-form-urlencoded"
    );

    xhrRemove.onreadystatechange = function () {
      if (xhrRemove.readyState === 4) {
        ADDING_TO_CART = false;
        if (xhrRemove.status === 200) {
          if (reload) {
            window.location.reload();
          }
          resolve(true);
        } else {
          console.error("Error al eliminar producto del carrito.");
          reject("Failed to remove product from cart.");
        }
      }
    };

    xhrRemove.send(`quantity=0&id=${productId}`);
  });
};

const VALIDATE_PRODUCT_IN_CART = async (productId, reload = false) => {
  if (ADDING_TO_CART) {
    return;
  }
  if (VALIDATING_CART) {
    return;
  }
  VALIDATING_CART = true;
  const items = await GET_ITEMS_IN_CART();
  if (items.length > 0) {    
    // check if product is in cart
    const productInCart = PRODUCT_IN_CART(items, productId);
    if (!productInCart) {
      // Add product default to cart
      await ADD_PRODUCT_TO_CART(productId, reload);
    } else {
      if (items.length == 1) {
        // Remove product default to cart
        await REMOVE_PRODUCT_TO_CART(productId, reload);
      }
    }
  }
  VALIDATING_CART = false;
  return true;
};

const VALIDATE_PRODUCTS_IN_CART = async (forceReload = true) => {
  //console.log('VALIDATE_PRODUCTS_IN_CART >>> ');
  if (ADDING_TO_CART) {
    return;
  }
  if (VALIDATING_CART) {
    return;
  }
  VALIDATING_CART = true;

  const items = await GET_ITEMS_IN_CART();
  let hasUpdates = false;
  if (items.length > 0) {
    for (let i = 0; i < items.length; i++) {
      const productOriginal = items[i];
      //console.log('productOriginal >> ', productOriginal);

      const productFreeId = PRODUCT_STORE[productOriginal.id];
      //console.log('product free >> ', productFreeId);

      if (!productFreeId) {
        continue
      }

      // Verificar si el producto asociado (free) está en el carrito
      const productInCart = PRODUCT_IN_CART(items, productFreeId);
      //console.log('product free in cart >> ', productInCart)

      if (!productInCart) {
        // Agregar producto al carrito y forzar reload después de cada adición
        await ADD_PRODUCT_TO_CART(productFreeId, productOriginal.quantity);
        //hasUpdates = true
        window.location.reload()
        return;
      } else {
        const productFree = items.find(item => item.id == productFreeId);
        if (productFree) {
          if (productFree.quantity != productOriginal.quantity) {
            //console.log("Eliminando producto FREE para reajustar cantidad...");
      
            // Eliminar el producto free del carrito
            await REMOVE_PRODUCT_FROM_CART(productFreeId, false);      
            //console.log("Reagregando producto FREE con cantidad actualizada...");
      
            // Agregarlo de nuevo con la cantidad del original
            await ADD_PRODUCT_TO_CART(productFreeId, productOriginal.quantity);
      
           // hasUpdates = true
          //window.location.reload() SE DEBE ACTIVAR PARA ACTUALIZAR LA CANTIDAD DEL PRODUCTO FREE EN EL CART
          return;
          }
        }
        //console.log("PRODUCTO FREEEEE: ", productFree);
        //console.log("ITEMS: ", items);
      }
    }

    if (hasUpdates && forceReload) {
      window.location.reload()
    }
  }

  VALIDATING_CART = false;
  return true;
};

async function REMOVE_PRODUCT_WITH_FREE_FROM_CART(originalProductId) {
  try {
    const productFreeId = PRODUCT_STORE[originalProductId];

    // Obtener la lista de productos en el carrito
    const items = await GET_ITEMS_IN_CART();
    
    // Contar cuántos productos originales quedan en el carrito
    const productCount = items.filter(item => PRODUCT_STORE[item.id] === productFreeId).length;

    // Si solo queda un producto original, elimina el producto gratuito
    if (productCount === 1 && productFreeId) {
      await REMOVE_PRODUCT_FROM_CART(originalProductId, false);
      await REMOVE_PRODUCT_FROM_CART(productFreeId, false);
      console.log('Producto gratuito eliminado:', productFreeId);
      window.location.reload()
    }

    // Elimina el producto original
    await REMOVE_PRODUCT_FROM_CART(originalProductId, false);
    console.log('Producto original eliminado:', originalProductId);

    // Opcional: Actualizar el carrito sin recargar la página
    VALIDATE_PRODUCTS_IN_CART(false);
    window.location.reload()
  } catch (error) {
    console.error('Error al eliminar productos del carrito:', error);
  }
};


$(document).ready(function () {
  const $cartIcon = $('#header .js-call-minicart')
  console.log('$cartIcon >> ', $cartIcon)
  if ($cartIcon.length > 0) {
    $cartIcon.click(function() {
      VALIDATE_PRODUCTS_IN_CART(false);
    })
  }
});

function isMobileDevice() {
    return window.innerWidth <= 768; 
}

// Agregar producto y redirigir en móviles
document.querySelector('.enj-add-to-cart-btn').addEventListener('click', async function(event) {
    if (isMobileDevice()) {
       /* console.log('PRESIONOO AGREGAR EN MOVIL >>>>>>>')*/
      await VALIDATE_PRODUCTS_IN_CART(false);
      window.location.href = 'https://glutactive.com/cart';     
    }
  
});


console.log('custom-glutactive.js loaded');